export const avatar = {
  cropTitle: "画像を切り抜き",
  cropImageAlt: "切り抜き対象の画像",
  upload: "アップロード",
  uploading: "アップロード中…",
  cancel: "キャンセル",
  uploadFailed: "アップロードに失敗しました",
  uploadSuccess: "プロフィール画像を更新しました",
} as const;
